import { render, staticRenderFns } from "./iptaldialog.vue?vue&type=template&id=1bbd03f6"
import script from "./iptaldialog.vue?vue&type=script&lang=js"
export * from "./iptaldialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports